function getProperties() {
  try {
    return {
      app_platform: window.navigator.platform || 'undefined',
      app_pwa_installed: window.matchMedia && window.matchMedia('(display-mode: standalone)').matches,
    }
  } catch {
    return {
      app_platform: 'error',
      app_pwa_installed: false,
    }
  }
}

export default {
  getProperties
}
